// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import { Link } from 'react-router-dom';

// function LoginForm() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [loading, setLoading] = useState(false); // 🛠️ New loading state added
//   const { loginUser } = useAuth();

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrorMessage('');
//     setLoading(true); // 🛠️ Start loader when form submits

//     try {
//       const response = await fetch('/api/user-login', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Login failed');
//       }

//       const data = await response.json();
//       console.log('Login successful:', data);

//       loginUser(data.user_email); // Set user email in context
//       navigate('/user-home'); // Redirect to dashboard
//     } catch (error) {
//       console.error('Error in login request:', error);
//       setErrorMessage(error.message || 'An error occurred during login');
//     } finally {
//       setLoading(false); // 🛠️ Stop loader after success/fail
//     }
//   };

//   return (
//     <form className="hw-login-form" onSubmit={handleSubmit}>
//       {/* Email Input */}
//       <div className="hw-input-group">
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c6a28c04ec51b8fc11cdf661362a6d97b44fd42b6a33e5528bd359c8ffbab84?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
//           alt="Email icon"
//           className="hw-input-icon"
//         />
//         <input
//           type="email"
//           placeholder="Email"
//           aria-label="Email"
//           className="hw-form-input"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />
//       </div>

//       {/* Password Input */}
//       <div className="hw-input-group">
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/4eaeb393e3e4c9afbbee777fd3c893ba7177c52e0b4352975c50b0730cd97b3d?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
//           alt="Password icon"
//           className="hw-input-icon"
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           aria-label="Password"
//           className="hw-form-input"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//       </div>

//       {/* Error Message */}
//       {errorMessage && <div className="error-message">{errorMessage}</div>}

//       {/* Submit Button */}
//       <button type="submit" className="hwu-login-button" disabled={loading}>
//         {loading ? 'Logging in...' : 'Login Now'}
//       </button>

//       {/* Forgot Password Link */}
//       <Link to="/forgot-password" className="hw-forgot-password">
//         Forgot Password?
//       </Link>
//     </form>
//   );
// }

// export default LoginForm;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import { Mail, Lock } from 'lucide-react';
import { getColor } from '@/config/theme';
import { normalizeEmail, isValidEmail } from '@/utils/formValidation';
 
function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
 
  const navigate = useNavigate();
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    const normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) {
      setErrorMessage('Email is required.');
      return;
    }
    if (!isValidEmail(normalizedEmail)) {
      setErrorMessage('Please enter a valid email address.');
      return;
    }
    if (!password) {
      setErrorMessage('Password is required.');
      return;
    }
    setLoading(true);
 
    try {
      const response = await fetch('/api/user-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: normalizedEmail, password }),
      });
 
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Login failed');
      }
 
      const data = await response.json();
 
      loginUser(data.user_email);
     
      // Check if there's an intended destination stored
      const intendedDestination = localStorage.getItem('intendedDestination');
      if (intendedDestination) {
        localStorage.removeItem('intendedDestination');
       
        if (intendedDestination === 'enhance-cv') {
          navigate('/create-resume');
        } else if (intendedDestination === 'jd-align-resume') {
          navigate('/create-resume');
        } else {
          navigate('/user-home');
        }
      } else {
        navigate('/user-home');
      }
    } catch (error) {
      console.error('Error in login request:', error);
      setErrorMessage(error.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
      <div className="space-y-4">
        <div className="relative group">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within:text-primary" />
          <Input
            type="email"
            placeholder="Enter your email"
            aria-label="Email"
            className="pl-10 h-10 transition-all"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
 
        <div className="space-y-2">
          <div className="relative group">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within:text-primary" />
            <Input
              type="password"
              placeholder="Enter your password"
              aria-label="Password"
              className="pl-10 h-10 transition-all"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="flex items-center justify-end">
            <Link 
              to="/forgot-password" 
              className={cn(
                "text-sm text-muted-foreground hover:text-primary",
                "transition-colors underline-offset-4 hover:underline"
              )}
            >
              Forgot password?
            </Link>
          </div>
        </div>
      </div>
 
      {errorMessage && (
        <div className="rounded-md bg-destructive/10 border border-destructive/20 p-3">
          <Text size="sm" variant="destructive" className="text-destructive">
            {errorMessage}
          </Text>
        </div>
      )}
 
      <Button 
        type="submit" 
        variant="default"
        size="default"
        disabled={loading}
        className="w-full h-11 font-semibold shadow-sm hover:shadow-md transition-all duration-200"
        style={{
          backgroundColor: getColor('primary'),
          color: getColor('primaryForeground'),
          borderColor: getColor('primary')
        }}
      >
        {loading ? 'Logging in...' : 'Sign In'}
      </Button>
    </form>
  );
}
 
export default LoginForm;
